export enum DefaultSortByOptions {
  DateCreated = 'DateCreated',
  Alphabetical = 'Alphabetical',
  Relevance = 'Relevance',
}
